import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'glamorous';
import classnames from 'classnames';
import ErrorList from '../../../../common/components/ErrorList';
import ActivityListTile, { displayProps } from './ActivityListTile';
import styles from './ActivityList.css';

const getLargestItem = items => {
  if (!items.length) {
    return {};
  }

  // find the item with the most detail props to get columns from
  let largestItem = items[0];
  items.forEach(item => {
    if (Object.keys(item).length > largestItem.length) {
      largestItem = item;
    }
  });

  return largestItem;
};

const fillEmptyProps = (baseObject, objToFill) => {
  // create object model
  const model = Object.keys(baseObject).reduce((acc, curr) => {
    return {
      ...acc,
      [curr]: '',
    };
  }, {});

  // merge existing props over it
  return {
    ...model,
    ...objToFill,
  };
};

const extractColumns = objToExtract => {
  return Object.keys(objToExtract).map(key => {
    const currProp = objToExtract[key];
    return {
      value: currProp.displayName || key,
      className:
        typeof currProp.headerClass === 'undefined'
          ? currProp.className
          : currProp.headerClass,
    };
  });
};

const ActivityList = ({
  title,
  mobileIcon = false,
  activities,
  isLoading = false,
  noDataMessage,
  loadingMessage,
  statusMessage,
  color,
  className,
  theme: { colors },
}) => {
  const noData = isLoading
    ? loadingMessage || 'Loading...'
    : noDataMessage || `There are no registered ${title || ''}`;
  const largestActivity = getLargestItem(
    activities.map(activity => activity.details)
  );
  const activitiesList = activities.map(activity => ({
    ...activity,
    details: fillEmptyProps(largestActivity, activity.details),
  }));
  const hasActions = activities.some(activity => !!activity.action);

  return (
    <div className={classnames(styles.activityList, className)}>
      {/* Header */}
      {title ? (
        <h4 className={styles.header} style={{ color: '#333333' }}>
          {title}
        </h4>
      ) : null}

      {/* Status Messaging */}
      {statusMessage ? <ErrorList {...statusMessage} /> : null}

      {/* Column Headers */}
      {activitiesList.length ? (
        <div
          className={classnames(styles.activityListTile, styles.columnLabel)}
          style={{ paddingTop: 0, paddingBottom: 0 }}
        >
          <div
            className={styles.avatarContainer}
            style={{ padding: '10px 0px' }}
          />
          {displayProps(extractColumns(largestActivity))}
          {hasActions ? (
            <div
              style={{
                width: '6rem',
                padding: '10px 0px',
              }}
            />
          ) : null}
        </div>
      ) : ( 
        <div className={styles.noDataMsg}>{noData}</div>
      )}

      {/* Activity Cards */}
      {activitiesList.map(activity => {
        const { id, ...rest } = activity;
        return (
          <ActivityListTile
            mobileIcon={mobileIcon}
            key={id}
            activity={rest}
          />
        );
      })}
    </div>
  );
};

ActivityList.propTypes = {
  title: PropTypes.string,
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool,
  noDataMessage: PropTypes.string,
  loadingMessage: PropTypes.string,
  mobileIcon: PropTypes.bool,
  statusMessage: PropTypes.shape({
    errors: PropTypes.arrayOf(PropTypes.string),
    actions: PropTypes.arrayOf(PropTypes.object),
  }),
  color: PropTypes.string,
  className: PropTypes.string,
};

export default withTheme(ActivityList);



// WEBPACK FOOTER //
// ./src/App/account/components/ActivitiesPage/ActivityList.js